import { render, staticRenderFns } from "./RecommendationListTable.vue?vue&type=template&id=45b65ca7&scoped=true&"
import script from "./RecommendationListTable.vue?vue&type=script&lang=js&"
export * from "./RecommendationListTable.vue?vue&type=script&lang=js&"
import style0 from "./RecommendationListTable.vue?vue&type=style&index=0&id=45b65ca7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b65ca7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCard,VDataTable,VIcon,VSelect,VSimpleTable,VTextarea})
